import React from 'react';
import moment from 'moment';
import dayjs from 'dayjs';
import styled from '@emotion/styled';

import { GiftcardEvent } from '@baemingo/giftcard-events/dist/types';

import { useCurrency, useI18n } from '~Hooks';

interface Props {
  historyEvents: GiftcardEvent[];
}

const GiftCardHistoryTable = styled.table`
  color: var(--colorBlueGray1300);
  margin-top: 16px;
  width: auto;
  border-collapse: collapse;
  border-left: 2px solid #eff1f3;
  position: relative;
  & > thead td {
    padding-bottom: 4px;
    font-size: 14px;
  }
  & tr > td:first-of-type {
    border-radius: 4px;
    padding-left: 24px;
  }
  & tr > td:last-child {
    border-radius: 4px;
    padding-right: 0;
  }
  & td {
    padding: 6px 24px;
    white-space: nowrap;
  }
  & tr {
    position: relative;
    &:before {
      content: '';
      border: 2px solid #eff1f3;
      background-color: white;
      border-radius: 50%;
      height: 12px;
      width: 12px;
      position: absolute;
      left: -8px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

const Amount = styled.b`
  &.ADD_BALANCE,
  &.REFUND {
    color: var(--colorUIGreen);
    &:before {
      content: '+ ';
    }
  }

  &.PAYMENT,
  &.DEDUCT_BALANCE {
    color: var(--colorUIRed);
    &:before {
      content: '- ';
    }
  }
`;

const ActionDate = styled.span`
  font-size: 12px;
  color: var(--colorBlueGray600);
  display: block;
`;

const GiftCardHistory = ({ historyEvents }: Props) => {
  const { i18n } = useI18n();
  const currency = useCurrency();

  const sortedHistory = [...historyEvents].sort((a, b) =>
    dayjs(a.sentAt || a.createdAt).isAfter(dayjs(b.sentAt || b.createdAt)) ? 1 : -1,
  );

  return (
    <GiftCardHistoryTable>
      <tbody>
        {sortedHistory?.map((event) => {
          return (
            <tr key={event.eventId}>
              <td>
                <Amount className={event.type}>
                  {/* I'm so sorry TypeScript */}
                  {(event as any).amount ? currency.format((event as any).amount) : ''}
                </Amount>
              </td>
              <td>
                {i18n(`GiftCard.Event.${event.type}`)}
                <ActionDate>{moment(event.createdAt).format('D MMMM YYYY, HH:mm:ss')}</ActionDate>
              </td>
            </tr>
          );
        })}
      </tbody>
    </GiftCardHistoryTable>
  );
};

export default GiftCardHistory;
